/* @jsxImportSource react */

import { Image } from '@packages/shared/src/ui/Image/Image';

interface ProductCardV2CustomFlagProps {
  src: string;
  alt?: string;
}

// TODO taken from ProductCard directly, refactor and/or extract
export const getImageFileName = (path: string): string => {
  const fileNameWithExtension = path.substring(path.lastIndexOf('/') + 1); // "file.txt"
  const fileName = fileNameWithExtension.split('.').slice(0, -1).join('.'); // "file"
  return fileName;
};

export const ProductCardV2CustomFlag = ({ src, alt }: ProductCardV2CustomFlagProps) => (
  <Image
    width={68}
    height={28}
    className="h-max max-h-[28px] object-contain object-left"
    src={src}
    alt={alt ?? getImageFileName(src)}
  />
);
